import React, { useMemo } from 'react';
import { Typography } from 'antd';
import cn from 'classnames';
import moment from 'moment';
import { groupAttachmentsByType } from '../../../../helpers/attachments/groupByType';
import Images from '../Images';
import Files from '../Files';
import { useEvents } from '../../providers/events';
import styles from './index.module.scss';

const CommentCard = ({ comment, bg, className }) => {
  const { files, images } = useMemo(() => {
    return groupAttachmentsByType(comment.attachments);
  }, [comment]);

  return (
    <div style={{ '--bg-color': bg }} className={cn(styles.root, className)}>
      {images.length > 0 && <Images data={images} commentId={comment.id} />}

      <Typography.Paragraph className={styles.note}>
        {comment.note}
      </Typography.Paragraph>

      {files.length > 0 && <Files data={files} commentId={comment.id} />}

      <Footer comment={comment} />
    </div>
  );
};

export default CommentCard;

function Footer({ comment }) {
  const { date, worker } = comment;

  const { getWorkerName } = useEvents();

  const { specialityName, companyName } = worker ?? {};

  const momentDate = moment(date);

  return (
    <div className={styles.footer}>
      <div className={styles.timeWrapper}>
        {renderText(momentDate.format('DD.MM.YYYY'))}
        {renderText(momentDate.format('HH:mm'))}
      </div>

      <div className={styles.metaWrapper}>
        {renderText(specialityName)}
        {renderText(getWorkerName(worker))}
        {renderText(companyName)}
      </div>
    </div>
  );
}

function renderText(value) {
  return value ? (
    <Typography.Text style={{ lineHeight: 1.1 }}>{value}</Typography.Text>
  ) : null;
}
